import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Shield18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5305 6.53033L11.4698 5.46967L8.00018 8.93933L6.53051 7.46967L5.46985 8.53033L8.00018 11.0607L12.5305 6.53033Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.25 0.29285C9.08831 0.235717 8.91193 0.235717 8.75024 0.29285L3.09236 2.2921C2.63276 2.45197 2.25012 2.92182 2.25012 3.42L2.25 11.65L2.25024 11.6635C2.27149 12.8459 2.93524 13.9801 3.95506 14.5779L8.58783 17.6265C8.83804 17.7912 9.16221 17.7912 9.41241 17.6265L14.0452 14.5779C15.065 13.9801 15.7289 12.8459 15.7501 11.6635V3.42C15.7501 2.9218 15.3675 2.45195 14.9078 2.29209L9.25 0.29285ZM3.75012 11.6427V3.65057L9.00012 1.79545L14.2501 3.65057V11.6427C14.2348 12.3673 13.822 12.9291 13.2378 13.3135L9.00012 16.1022C7.58347 15.1699 6.19352 14.1379 4.725 13.2904C4.14403 12.9551 3.7643 12.3132 3.75012 11.6427Z'
      fill='currentColor'
    />
  </Svg>
);

Shield18.displayName = 'Shield18';
export default Shield18;
